const VideoPlayIcon = () => {
  return (
    <>
      <svg
        version='1.0'
        xmlns='http://www.w3.org/2000/svg'
        width='45%'
        height='45%'
        viewBox='0 0 980.000000 980.000000'
        preserveAspectRatio='xMidYMid meet'>
        <g
          transform='translate(0.000000,980.000000) scale(0.100000,-0.100000)'
          fill='#FFFFFF'
          stroke='none'>
          <path
            d='M4675 8494 c-541 -44 -999 -172 -1440 -403 -544 -285 -1015 -711
-1347 -1221 -306 -468 -496 -993 -565 -1560 -24 -202 -24 -630 1 -825 90 -710
361 -1348 796 -1870 609 -731 1427 -1177 2370 -1292 202 -24 630 -24 825 1
870 110 1599 477 2201 1106 469 490 791 1119 918 1790 49 261 60 376 60 675 0
309 -12 443 -65 710 -197 992 -806 1857 -1675 2380 -430 259 -891 419 -1404
486 -149 20 -548 33 -675 23z m-500 -1912 c28 -10 217 -114 420 -232 204 -117
469 -271 590 -341 528 -305 1113 -643 1274 -735 197 -113 251 -155 289 -228
24 -45 27 -62 27 -146 0 -84 -3 -101 -27 -147 -39 -73 -87 -110 -308 -237
-107 -62 -458 -265 -780 -451 -888 -512 -1276 -736 -1375 -793 -105 -59 -165
-77 -240 -69 -143 15 -257 120 -285 262 -17 91 -10 2866 8 2917 7 21 27 56 45
79 92 120 232 167 362 121z'
          />
        </g>
      </svg>
    </>
  );
};

export default VideoPlayIcon;
